import React from 'react';
import LoginButton from './LoginButton';
import { useBrandName } from '../hooks/useBrandName';

const LoginPage: React.FC = () => {
  const brandName = useBrandName();
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-cyan-50 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-cyan-200 rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      {/* Login card */}
      <div className="relative bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl p-8 sm:p-12 max-w-md w-full border border-gray-200 animate-scale-in">
        <div className="text-center mb-8">
          <img
            src="/logo.jpg"
            alt={brandName}
            className="w-32 h-32 mx-auto mb-6 rounded-2xl shadow-lg object-cover transform hover:scale-105 transition-transform duration-300"
          />
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-3">
            {brandName}
          </h1>
          <p className="text-gray-600 text-lg font-medium">Itinerary Management</p>
        </div>
        
        <div className="mb-8">
          <p className="text-gray-700 mb-6 text-center">Sign in to access your travel itineraries</p>
          <LoginButton />
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 text-center">Powered by {brandName}</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
